export default __webpack_public_path__ + "static/media/worku.2eba099d.jpg";